import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SourTrackIndicator, buildSourTrackIndicator } from './sourtrack-sync.utils';

/** Presentational: shows where the SourTrack sync of an opportunity stands and offers the manual retry. */
@Component({
  selector: 'app-sourtrack-sync-status',
  standalone: false,
  templateUrl: './sourtrack-sync-status.component.html',
  styleUrls: ['./sourtrack-sync-status.component.less'],
})
export class SourTrackSyncStatusComponent {
  @Input() status: string | null | undefined = null;
  @Input() detail: string | null | undefined = null;
  @Input() canRetry = false;
  @Input() retrying = false;
  @Output() retry = new EventEmitter<void>();

  get indicator(): SourTrackIndicator | null {
    return buildSourTrackIndicator(this.status, this.detail);
  }
}
